"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Info = void 0;

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var Info = {}; // Object.assign

exports.Info = Info;

if (!('assign' in Object)) {
  Object.assign = function (target, ...args) {
    args.forEach(object => {
      Object.keys(object).forEach(key => {
        target[key] = object[key];
      });
    });
    return target;
  };

  Info.objectAssign = true;
}

if (!_exports.default.Channel && !('forEach' in NodeList.prototype)) {
  Object.defineProperty(NodeList.prototype, 'forEach', {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function forEach(callback, self) {
      for (var i = 0; i < this.length; i++) {
        callback.call(self, this[i]);
      }
    }
  });
  Info.nodeListForEach = true;
}

if (!_exports.default.Channel) {
  var E = document.createElement('div');
  Info.objectFit = 'objectFit' in E.style;
  Info.objectPosition = 'objectPosition' in E.style;

  try {
    E.innerHTML = "<div class='foo'></div>";
    E.querySelector(':scope > .foo');
    Info.scopedSelector = true;
  } catch (err) {
    Element.prototype._baseQuerySelector = Element.prototype.querySelector;
    Element.prototype._baseQuerySelectorAll = Element.prototype.querySelectorAll;

    Element.prototype.querySelector = function (selector) {
      if (/:scope/.test(selector)) {
        return this._doScopedQuery(selector, this._baseQuerySelector);
      }

      return this._baseQuerySelector(selector);
    };

    Element.prototype.querySelectorAll = function (selector) {
      if (/:scope/.test(selector)) {
        return this._doScopedQuery(selector, this._baseQuerySelectorAll);
      }

      return this._baseQuerySelectorAll(selector);
    };

    Element.prototype._doScopedQuery = function (selector, which) {
      if (this.parentNode) {
        selector = selector.replace(/:scope/g, '[data-qsa-root=true]');
        this.dataset.qsaRoot = 'true';
        var r, e;

        try {
          r = which.call(this.parentNode, selector);
        } catch (err) {
          e = err;
        }

        delete this.dataset.qsaRoot;
        if (e) throw e;
        return r;
      }

      selector = selector.replace(/:scope/g, '');
      return which.call(this, selector);
    };

    Info.scopedSelector = false;
  }

  if (!('remove' in E)) {
    Info.elementRemove = false;

    Element.prototype.remove = function () {
      var _this$parentNode;

      (_this$parentNode = this.parentNode) === null || _this$parentNode === void 0 ? void 0 : _this$parentNode.removeChild(this);
    };

    CharacterData.prototype.remove = DocumentType.prototype.remove = Element.prototype.remove;
  } else {
    Info.elementRemove = true;
  }
}